import { Component, Inject, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { CoreService } from 'src/app/core/helpers/core.service';
import { ToastrService } from 'ngx-toastr';
import { TranslateService } from '@ngx-translate/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';

@Component({
  selector: 'loyaltic-info',
  templateUrl: './info.component.html',
  styleUrls: ['./info.component.scss']
})
export class InfoComponent implements OnInit {
  @ViewChild('emailReminderModal', { static: false }) emailReminderModalRef: TemplateRef<any>;
  UserName = '';
  adminLock = true;
  modalRef: BsModalRef;

  popupConfig = {
    ignoreBackdropClick: false,
    class: 'lyltc win modal-md modal-dialog-centered',
  };

  constructor(@Inject('ImagePath') public ImagePath,
    private coreService: CoreService, private toast: ToastrService,
    public translate: TranslateService,
    private modalService: BsModalService) { }

  ngOnInit() {
    if (window.location.pathname === "/admin") {
      this.adminLock = false;
    }
  }

  onSubmit(form) {
    this.coreService.signUp(this.UserName).then((response: any) => {
      form.submitted = false;
      this.UserName = '';
      const messageKey = response.messageKey;
      this.toast.success(this.translate.instant('' + messageKey), this.translate.instant('success'));
    });
  }

  openReminderModal(): void {
    this.modalRef = this.modalService.show(this.emailReminderModalRef, this.popupConfig);
  }

  closeReminderModal(): void {
    if (this.modalRef) {
      this.modalRef.hide();
    }
  }

}
